/**
 * 校验
 */

// 判断是否是邮箱
export const isEmail = (s) => {
  return (
    typeof s === "string" &&
    s.length <= 320 &&
    !!s.match(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/
    )
  )
}

export const isEmailCommon = (str, options = {}) => {
  const defaultOptions = {
    userNameCharacter: "._%-",
    domainCharacter: "-",
    userNameLength: 64,
    domainLength: 253,
    domainSubPartMinLength: 1,
    domainSubPartMaxLength: 63
  }
  if (Object.prototype.toString.call(options) === "[object Object]") {
    options = Object.assign({}, defaultOptions, options)
  }
  const {
    userNameCharacter = "._%-",
    domainCharacter = "-",
    userNameLength = 64,
    domainLength = 253,
    domainSubPartMinLength = 1,
    domainSubPartMaxLength = 63
  } = options
  const hasAtOnlyReg = /@{1,1}/
  const hasPointReg = /\./

  const userNameAllowedChars = `a-zA-Z0-9${userNameCharacter}`
  const userNameReg = new RegExp(`^[${userNameAllowedChars}]+$`)

  const domainRegAllowedChars = `a-zA-Z0-9${domainCharacter}`
  const domainReg = new RegExp(`^[${domainRegAllowedChars}.]+$`)

  // 判断是否有@符
  if (!hasAtOnlyReg.test(str)) {
    return false
  }

  // 解构用户名和域名部分
  const [userName, domain] = str.split("@")

  // 校验用户名
  if (userName.length > userNameLength) {
    return false
  }
  if (!userNameReg.test(userName)) {
    return false
  }
  // 检查是否以特殊字符开头或结尾
  const firstChar = userName[0]
  const lastChar = userName[userName.length - 1]
  if (
    userNameCharacter.includes(firstChar) ||
    userNameCharacter.includes(lastChar)
  ) {
    return false
  }

  // 检查是否包含连续的特殊字符
  for (let i = 0; i < userName.length - 1; i++) {
    const currentChar = userName[i]
    const nextChar = userName[i + 1]
    if (
      userNameCharacter.includes(currentChar) &&
      userNameCharacter.includes(nextChar)
    ) {
      return false
    }
  }

  // 校验域名
  if (domain.length > domainLength) {
    return false
  } else if (!hasPointReg.test(domain)) {
    return false
  } else if (!domainReg.test(domain)) {
    return false
  }

  // 顶级域（最后一部分）至少 2 个字符
  const parts = domain.split(".")
  const topLevelDomain = parts[parts.length - 1]
  if (topLevelDomain.length < 2) {
    return false
  }

  // 检查各部分（由点分隔）的长度限制
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i]
    if (
      part.length < domainSubPartMinLength ||
      part.length > domainSubPartMaxLength
    ) {
      return false
    }
  }

  // 检查是否以连字符开头或结尾
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i]
    if (part.startsWith("-") || part.endsWith("-")) {
      return false
    }
  }

  return true
}

// 判断是否url
export const isURL = (s) => {
  return /^http[s]?:\/\/.*/.test(s)
}
// 判断是不是对象
export const isObject = (val) => {
  return Object.prototype.toString.call(val) === "[object Object]"
}
// 判断是不是图片文件
export const isImgFile = (
  file,
  imgTypes = ["jpg", "jpeg", "png", "webp", "gif", "bmp"]
) => {
  if (!(file instanceof File)) {
    return false
  }
  return imgTypes.includes(file.type.split("/")[1])
}
//判断非空
export const isEmpty = (v) => {
  switch (typeof v) {
    case "undefined":
      return true
    case "string":
      if (v.trim().length == 0) return true
      break
    case "boolean":
      if (!v) return true
      break
    case "number":
      if (0 === v) return false
      break
    case "object":
      if (null === v) return true
      if (undefined !== v.length && v.length == 0) return true
      for (var k in v) {
        return false
      }
      break
  }
  return false
}
// 判断是否为json
export const isJson = (value) => {
  if (typeof value === "string") {
    try {
      const obj = JSON.parse(value)
      return !!(typeof obj === "object" && obj)
    } catch (ignore) {}
  }
  return false
}

/**
 *  注意：：：过期随时会删除，项目中及时替换【isSpecifyNum方法】
 * @param {*} value
 * @returns  判断是否为数字且最多两位小数
 */
// export const isNum = (value) => {
//   const reg = /^\d+(\.\d{1,2})?$/;
//   return reg.test(value);
// };

// 判断是否是身份证号(第二代)
export const isIdCard = (value, X) => {
  let reg = ""
  if (X) {
    reg =
      /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$/
  } else {
    reg =
      /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  }

  return reg.test(value)
}
// 判断是否是数组
export const isArray = (arg) => {
  if (typeof Array.isArray === "undefined") {
    return Object.prototype.toString.call(arg) === "[object Array]"
  }
  return Array.isArray(arg)
}
// 判读是否为外链
export const isExternal = (path) => {
  return /^(https?:|mailto:|tel:)/.test(path)
}

//手机号
export const isPhone = (s) => {
  return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(s)
}
// 邮编校验
export const isPostCode = (s) => {
  return /^[0-9]{6}$/.test(s)
}
// 6位长度密码校验，仅支持数字字母特殊符号
export const isPassword = (s) => {
  return /^[0-9A-Za-z_!@#$%^&*`~()-+=.:;'/]{6}$/.test(s)
}

// 密码校验 至少 1 个大写字母；至少 1 个小写字母；至少 1 个数字；至少 num 位长度 默认8位；
export const isPasswordRules = (s, num = 8) => {
  const regex = new RegExp(`^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[^]{${num},}$`)
  return regex.test(s)
}

// 字符串的长度至少为5个字符,字符串只能包含字母、数字、下划线和破折号,字符串不能以破折号开头或结尾。

export const isPostCodeRules = (s) => {
  return /^(?!-)[\w-]{5,}(?<!-)$/.test(s)
}

// 中文效验
// export const isChinese = (s) => {
//   return /^[\u4E00-\u9FA5]+$/.test(s);
// };

/**
 * 注意：：：过期随时会删除，项目中及时替换【isSpecifyNum方法】
 * @param {*} s
 * @returns >=0最多三位小数
 */
// export const isMoney = (s) => {
//   return /^\d+(\.\d{1,3})?$/.test(s);
// };
// 正整数效验
export const isPositiveInt = (s) => {
  return /^[1-9]\d*$/.test(s)
}
// 统一社会信用代码
export const isCreditCode = (s) => {
  return /^[A-Z0-9]{18}$/.test(s)
}
//是否英文
// export const isEnglsh = (s) => {
//   return /^[a-z|A-Z]*$/.test(s);
// };
// 非中文校验
export const isNotChinese = (s) => {
  return !/[\u4e00-\u9FA5]/g.test(s)
}
//电话效验
export const isTel = (s) => {
  return /^[0-9|\-{1}]*$/.test(s)
}
//数字内是否重复
export const isArrayValueRepet = (arr) => {
  var hash = {}
  for (var i in arr) {
    if (hash[arr[i]])
      //hash 哈希
      return true
    hash[arr[i]] = true
  }
  return false
}

// 严格的电话或者手机号校验
export const isStrictTelPhone = (value) => {
  var telReg =
    /^(400|800)([0-9\\-]{7,10})|(([0-9]{4}|[0-9]{3})([- ])?)?([0-9]{7,8})(([- 转])*([0-9]{1,4}))?$/
  var phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  if (!(phoneReg.test(value) || telReg.test(value))) {
    return false
  }
  return true
}

// 判断是否是汇率(正数)
export const isRate = (value) => {
  var reg =
    /^[+]{0,1}[1-9]\d*$|^[+]{0,1}(0\.\d*[1-9])$|^[+]{0,1}([1-9]\d*\.\d*[1-9])$/g
  return reg.test(value)
}

// 大于0且小于1，保留小数点后一位
export const validateDecimalRange = (value) => {
  var reg = /^[0]\.[0-9]$/
  return reg.test(value)
}

//座机电话，区号3-4位，电话长度7-8位
export const isTelephone = (value, areaCode) => {
  let reg = ""
  if (areaCode) {
    reg = /^(\d{3,4}-)\d{7,8}$/
  } else {
    reg = /^(\d{3,4}-)?\d{7,8}$/
  }

  return reg.test(value)
}

//仅支持数字和字母
// export const isNumStr = (value) => {
//   let reg = /^[a-zA-Z0-9]+$/;
//   return reg.test(value);
// };

// 非严格限制电话（数字和横杠）
export const isNoStrictPhone = (value) => {
  var reg = /^[0-9|0-9-]+$/
  return reg.test(value)
}

// 严谨手机号校验
export const isStrictPhone = (value) => {
  var reg = /^0?(13[0-9]|15[012356789]|166|17[013678]|18[0-9]|14[57])[0-9]{8}$/
  return reg.test(value)
}

// tms名称校验--汉字字母数字可以输入，符号不可以输入
// export const isChineseName = (value) => {
//   var reg =  /^[\u4e00-\u9fa5A-Za-z0-9]+$/;
//   return reg.test(value);
// };

// 英文名称校验 限制英文+空格
// export const isEnglishName = (value) => {
//   var reg =/^[A-Z a-z]+$/;
//   return reg.test(value);
// };

// 校验正数（最多两位小数）
/**
 * 注意：：：过期随时会删除，项目中及时替换【isSpecifyNum方法】
 * @param {*} s
 * @returns >=0最多2位小数
 */
// export const isDoublePlusNumber = (value) => {
//   var reg = /^(([1-9]{1}\d*)|([0]{1}))(\.\d{1,2})?$/;
//   return reg.test(value);
// };

// 允许负数（最多两位小数）
export const isDoubleNumber = (value) => {
  var reg = /(^-?(?:\d+|\d{1,3}(?:\d{3})+)(?:\.\d{1,2})?$)/
  return reg.test(value)
}

// 校验double（最多两位小数）可为0.00
export const isRateNumber = (value) => {
  var reg = /^[0-9]+([.]{1}[0-9]{1,2})?$/
  return reg.test(value)
}

//>=0 且最多保留指定位数小数
export let isSpecifyNum = (value, num) => {
  const reg = new RegExp("^\\d+(.\\d{1," + num + "})?$")
  return reg.test(value)
}
// 校验车牌号
export const isVehicleNo = (value) => {
  var xreg =
    /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/
  var creg =
    /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/
  if (value) {
    if (value.length == 7) {
      return creg.test(value)
    } else {
      return xreg.test(value)
    }
  } else {
    return false
  }
}

/***
 type:
1:数字
2：英文
3：汉字
4：数字+英文
5：数字+中文
6：英文+中文
7：数字+英文+汉字
8：数字+英文+特殊字符
11:数字 + 空格
22：英文+ 空格
33：汉字+ 空格
44：数字+英文+ 空格
55：数字+中文+ 空格
66：英文+中文+ 空格
77：数字+英文+汉字+ 空格
88：数字+英文+特殊字符 + 空格

len:字符串，6位长度 {6}, 3-6位长度{3,6}
**/
export const isFormatNumStrChinese = (value, type, len) => {
  let num = "0-9"
  let en = "a-zA-Z"
  let zh = "\u4e00-\u9fa5"
  let nul = " "
  let sym = "_!@#$%^&*`~()-+=.:;'/"
  let res = ""
  switch (String(type)) {
    case "1":
      res = num
      break
    case "2":
      res = en
      break
    case "3":
      res = zh
      break
    case "4":
      res = num + en
      break
    case "5":
      res = num + zh
      break
    case "6":
      res = en + zh
      break
    case "7":
      res = num + en + zh
      break
    case "8":
      res = num + en + sym
      break
    case "11":
      res = num + nul
      break
    case "22":
      res = en + nul
      break
    case "33":
      res = zh + nul
      break
    case "44":
      res = num + en + nul
      break
    case "55":
      res = num + zh + nul
      break
    case "66":
      res = en + zh + nul
      break
    case "77":
      res = num + en + zh + nul
      break
    case "88":
      res = num + en + sym + nul
      break
  }
  let reg = ""
  if (len) {
    reg = new RegExp("^[" + res + "]" + len + "$")
  } else {
    reg = new RegExp("^[" + res + "]+$")
  }
  return reg.test(value)
}
